module.exports = __webpack_public_path__ + "static/media/heart-svgrepo-com.0e786920.svg";